import { spBenefitTokenBatchLocs } from './components/benefit-token-batch/benefit-token-batch.locs';
import { spBenefitTokenCountsLocs } from './components/benefit-token-counts/benefit-token-count.locs';
import { spBenefitTokenImportLocs } from './components/benefit-token-import/benefit-token-import.locs';
import { spBenefitTokenInvalidateModalLocs } from './components/benefit-token-invalidate-modal/benefit-token-invalidate-modal.locs';
import { spBenefitTokenSearchLocs } from './components/benefit-token-search/benefit-token-search.locs';
import { spBenefitTokenLocs } from './components/benefit-tokens/benefit-token.locs';

export const spBenefitTokensModuleLocs = {
	...spBenefitTokenCountsLocs,
	...spBenefitTokenSearchLocs,
	...spBenefitTokenInvalidateModalLocs,
	...spBenefitTokenBatchLocs,
	...spBenefitTokenImportLocs,
	...spBenefitTokenLocs,
};
